'use client';

import { useRef, type MouseEvent, type ReactNode, type CSSProperties } from 'react';
import { useInView } from 'framer-motion';

interface FCardProps {
  id: string;
  index: number;
  cardType: 'process' | 'courses';
  onOpen: () => void;
  icon: ReactNode;
  tag: string;
  title: string;
  description: string;
  ctaLabel: string;
}

/** Combines scripts.js banners 6 (reveal) + 11 (card glow) + 13 (modal trigger) on servicios cards. */
export default function FCard({ id, index, cardType, onOpen, icon, tag, title, description, ctaLabel }: FCardProps) {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, { once: true, amount: 0.15, margin: '0px 0px -50px 0px' });

  const handleMouseMove = (e: MouseEvent<HTMLDivElement>) => {
    const el = ref.current;
    if (!el) return;
    const rect = el.getBoundingClientRect();
    el.style.setProperty('--mouse-x', `${e.clientX - rect.left}px`);
    el.style.setProperty('--mouse-y', `${e.clientY - rect.top}px`);
  };

  return (
    <div
      ref={ref}
      id={id}
      data-card-type={cardType}
      className={`f-card reveal${isInView ? ' active' : ''}`}
      style={{ '--i': index } as CSSProperties}
      onMouseMove={handleMouseMove}
      onClick={onOpen}
    >
      <div className="card-icon-area">{icon}</div>
      <div className="f-info">
        <span>{tag}</span>
        <h3>{title}</h3>
        <p className="card-desc">{description}</p>
        <div className="v-btn-card">{ctaLabel}</div>
      </div>
    </div>
  );
}
